// extracted by mini-css-extract-plugin
module.exports = {"local":"Sections_local__1YXhq","col_center":"Sections_col_center__3IjPO"};